import { Suggestions } from '@mint-sdk/api-recommendations';
import { formatDistanceToNowStrict } from 'date-fns';

import type { SuggestionHeaderStatus } from '../types/chips.js';

type Props = {
  status: SuggestionHeaderStatus;
  decisionTime: Suggestions.SuggestionResponseType['decisionTime'];
  expiredAt: Suggestions.SuggestionResponseType['expiredAt'];
  reworkDate: Suggestions.SuggestionResponseType['reworkDate'];
};

const useSuggestionTimeRange = ({
  status,
  decisionTime,
  expiredAt,
  reworkDate,
}: Props) => {
  const isExpired = status === Suggestions.Statuses.EXPIRED;
  const isReworking = status === Suggestions.Statuses.REWORKING;

  const expiredOrDecisionTime = isExpired ? expiredAt : decisionTime;
  const utcDecisionTime = `${isReworking ? reworkDate : expiredOrDecisionTime}Z`;

  const distanceTime = formatDistanceToNowStrict(new Date(utcDecisionTime));

  const [num, range] = distanceTime.split(' ');

  return {
    timeRangeArray: [num, range],
  };
};

export default useSuggestionTimeRange;
